import { Link } from 'react-router-dom';

export default function PortalPreview() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 gap-16 items-center">
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-12 flex items-center justify-center">
            <div className="w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/a9c67eb27cfd78ea05929485ed881af1.jpg"
                alt="Client Portal Dashboard"
                className="w-full h-auto rounded-lg shadow-2xl transform perspective-1000 rotate-y-5"
                style={{ transform: 'perspective(1000px) rotateY(-5deg)' }}
              />
            </div>
          </div>

          <div>
            <p className="text-sm font-medium text-gray-500 mb-3">Secure Client Access</p>
            <h2 className="text-5xl font-bold text-[#1a2b4a] mb-2">Manage Your Cases</h2>
            <h2 className="text-5xl font-light text-[#1a2b4a] mb-2">From Anywhere,</h2>
            <h2 className="text-5xl font-bold text-[#1a2b4a] mb-8">Anytime</h2>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl mt-1"></i>
                <div>
                  <p className="text-base text-gray-700 font-medium">Upload and store documents securely</p>
                  <p className="text-sm text-gray-600">Cloud-based storage with bank-level encryption</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl mt-1"></i>
                <div>
                  <p className="text-base text-gray-700 font-medium">Track service attempts in real-time</p>
                  <p className="text-sm text-gray-600">GPS tracking and instant status updates</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl mt-1"></i>
                <div>
                  <p className="text-base text-gray-700 font-medium">Access completed proofs of service</p>
                  <p className="text-sm text-gray-600">Instant download and print capabilities</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl mt-1"></i>
                <div>
                  <p className="text-base text-gray-700 font-medium">Generate and print court documents</p>
                  <p className="text-sm text-gray-600">Small claims forms and proof of service templates</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl mt-1"></i>
                <div>
                  <p className="text-base text-gray-700 font-medium">Manage multiple cases and customers</p>
                  <p className="text-sm text-gray-600">Organized dashboard with advanced filtering</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl mt-1"></i>
                <div>
                  <p className="text-base text-gray-700 font-medium">Assign courts to store locations</p>
                  <p className="text-sm text-gray-600">Streamlined court assignment management</p>
                </div>
              </div>
            </div>

            <Link
              to="/client-management"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#1a2b4a] text-white text-base font-medium rounded-full hover:bg-[#2a3b5a] transition-colors cursor-pointer whitespace-nowrap"
            >
              Access Client Portal
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
